import type { ReactNode } from 'react';
import styles from './ConfirmDialog/ConfirmDialog.module.css';

export interface DialogActionsProps {
  readonly children: ReactNode;
  readonly className?: string;
  readonly testId?: string;
  /**
   * When true, omit chrome padding/border/safe-area — host (e.g. AppModal footer)
   * already owns them. Keeps gap + flex alignment only.
   */
  readonly embedded?: boolean;
}

/**
 * Spec §7.9 Dialog Actions SoT — thin shared footer row.
 * Aliases ConfirmDialog footer geometry (gap / border / padding / safe-area).
 */
export function DialogActions({
  children,
  className,
  testId = 'dialog-actions',
  embedded = false,
}: DialogActionsProps): JSX.Element {
  const classNames = [embedded ? styles.footerEmbedded : styles.footer, className]
    .filter(Boolean)
    .join(' ');
  return (
    <div className={classNames} data-testid={testId} data-dialog-actions-embedded={embedded || undefined}>
      {children}
    </div>
  );
}
